var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.3734 10.3603C23.28 10.347 23.1867 10.347 23.0934 10.3603C21.0267 10.2937 19.3867 8.60032 19.3867 6.52032C19.3867 4.40032 21.1067 2.66699 23.2401 2.66699C25.3601 2.66699 27.0934 4.38699 27.0934 6.52032C27.0801 8.60032 25.44 10.2937 23.3734 10.3603Z",
    fill: "#090129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.7195 19.5995C26.2261 20.5995 24.1328 20.9729 22.1995 20.7195C22.7061 19.6262 22.9728 18.4129 22.9862 17.1329C22.9862 15.7996 22.6928 14.5329 22.1328 13.4262C24.1061 13.1596 26.1995 13.5329 27.7061 14.5329C29.8128 15.9195 29.8128 18.1995 27.7195 19.5995Z",
    fill: "#090129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.58718 10.3603C8.68052 10.347 8.77385 10.347 8.86719 10.3603C10.9339 10.2937 12.5739 8.60032 12.5739 6.52032C12.5739 4.40032 10.8539 2.66699 8.72052 2.66699C6.60052 2.66699 4.86719 4.38699 4.86719 6.52032C4.88052 8.60032 6.52052 10.2937 8.58718 10.3603Z",
    fill: "#090129"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.73349 17.1332C8.73349 18.4265 9.01349 19.6532 9.52015 20.7598C7.64015 20.9598 5.68016 20.5598 4.24016 19.6132C2.13349 18.2132 2.13349 15.9331 4.24016 14.5331C5.66682 13.5731 7.68016 13.1865 9.57349 13.3998C9.02682 14.5198 8.73349 15.7865 8.73349 17.1332Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1604 21.16C16.0537 21.1467 15.9337 21.1467 15.8137 21.16C13.3604 21.08 11.4004 19.0667 11.4004 16.5867C11.4004 14.0533 13.4404 12 15.9871 12C18.5204 12 20.5737 14.0533 20.5737 16.5867C20.5737 19.0667 18.6271 21.08 16.1604 21.16Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8264 23.9195C9.81307 25.2662 9.81307 27.4795 11.8264 28.8129C14.1197 30.3462 17.8797 30.3462 20.1731 28.8129C22.1864 27.4662 22.1864 25.2529 20.1731 23.9195C17.8931 22.3862 14.1331 22.3862 11.8264 23.9195Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon3);
export default __webpack_public_path__ + "static/media/ser-icon-3.9374a28a5d25ae69133971c52aa95b24.svg";
export { ForwardRef as ReactComponent };